module.exports = __webpack_public_path__ + "static/media/02_home_page.c91d5d90.gif";